import React from 'react'
import style from './footer.module.css'

function Footer() {
  return (
    <nav className={style.container}>
      
      {/* <ul>
        <li> Create Activitie</li>
        <li> Home</li>
      </ul> */}
      
    </nav>
  )
};

export default Footer